export enum VerifyIdentityMethodType {
    email = 'Email',
    sms = 'SMS'
}
